import * as angular from 'angular';

export const ModeCommonConstantsModule = angular.module('mode.common.constants', []).name;
